// ============================================================
// FILE: ThirdPartyFieldIcons.ts
// ============================================================
// Shared icon mappings for all third-party screens - top-level
// feature list (ThirdParties.tsx), sub-feature list within a
// category (ListofServices.tsx), and dynamic connection fields
// keyed by `fieldName` from `compConfigFeatureFeeList` (Zoho ERP,
// Stripe, Magnati, ...). Centralizing this here means every
// screen shares one source of truth instead of maintaining its
// own copy of these maps.
//
// To add an icon for a new feature, sub-feature, or field, just
// add an entry to the relevant map below - no changes needed in
// the individual screens.

// Keyed by ThirdPartyFeature.featureId (top-level category, e.g.
// ERP, POS, Ecommerce, Loyalty, HR Management, Payment Gateway).
export const FEATURE_ICON_MAP: Record<string, string> = {
  "7": "erp.svg",
  "8": "pos.svg",
  "9": "ecommerce.svg",
  "10": "loyalty.svg",
  "11": "hrmanagement.svg",
  "12": "payment-gateway.svg",
  default: "erp.svg",
};

// Keyed by SmeFeatureFee.subFeatureId (the individual integration
// within a category, e.g. Zoho, Stripe, Magnati).
export const SUBFEATURE_ICON_MAP: Record<string, string> = {
  "245": "growxerp.svg", // GrowX ERP
  "247": "zoho.svg", // Zoho Integration
  "151": "growxerp.svg",
  "13": "tally.svg",
  "14": "zoho.svg",
  "249": "stripe.svg", // Stripe Payment Gateway
  "257": "maganati.svg", // Magnati Payment Gateway
  "250": "rfm.svg",
  "248": "rfm.svg",
  default: "growxerp.svg",
};

// Keyed by the `fieldName` value coming back from
// `compConfigFeatureFeeList`, used by the dynamic connection
// field screens (Zoho ERP, Stripe, Magnati, ...).
export const FIELD_ICONS: Record<string, string> = {
  // Zoho ERP
  "Organization ID": "org2.svg",
  "Client ID": "ids.svg",
  "Client Secret": "lock.svg",
  "Base URL": "link.svg",

  // Stripe
  "Secret Key": "lock.svg",
  "Publishable Key": "lock.svg",
  "Webhook Secret": "lock.svg",

  // Magnati
  "User Name": "name-input.svg",
  "Password": "lock.svg",
  "Customer": "companyid.svg",
  "Store ID": "store.svg",
  "Merchant ID": "org2.svg",
  "Terminal ID": "ids.svg",
  "API Key": "lock.svg",
};

export const getFeatureIcon = (id: number | string): string =>
  FEATURE_ICON_MAP[id] ?? FEATURE_ICON_MAP.default;

export const getSubFeatureIcon = (id: number | string): string =>
  SUBFEATURE_ICON_MAP[id] ?? SUBFEATURE_ICON_MAP.default;